import { styled } from '@mui/material/styles';

interface RootProps { allowStickyFooter: boolean; showPreview?: boolean }

export const Root = styled('div')<RootProps>(({ theme, allowStickyFooter, showPreview }) => ({
  backgroundColor: theme.palette.general.lightGrey8,
  opacity: 1,
  padding: theme.spacing(3),
  position: allowStickyFooter ? 'sticky' : 'relative',
  bottom: 0,
  display: 'flex',
  ...(showPreview ? {
    gap: theme.spacing(2),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      '& .content': {
        width: '100%',
      },
    },
  } : {
    alignItems: 'flex-end',
    flexDirection: 'column',
  }),

  '& .coupon, & .continueShopping': {
    backgroundColor: theme.palette.general.lightGrey8,
  },
  marginTop: theme.spacing(2),
}));

export const Content = styled('div')(() => ({
  width: '50%',
  position: 'relative',
}));
